import { AxiosResponse } from 'axios'

const resource = http => ({
  getAll() {
    return http({
      method: 'get',
      url: `/advertisers`
    })
  }
})

export interface AdvertisersHttpModel {
  getAll: () => Promise<AxiosResponse>
}

export default resource
